import React from "react";
import T from "prop-types";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    this.setState({ error });
    if (process.env.ROLLBAR_CLIENT_ACCESS_TOKEN) {
      // eslint-disable-next-line
      Rollbar.error(error);
    }
  }

  render() {
    const { error } = this.state;
    const { children, notification } = this.props;

    if (error) {
      return (
        <tr>
          <td>
            <span style={{ color: "red" }}>
              Error loading notification type{" "}
              <strong>{notification.notification_type}</strong>: {error.message}
            </span>
          </td>
          <td />
          <td />
        </tr>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: T.oneOfType([T.node, T.arrayOf(T.node)]),
  notification: T.shape({
    notification_type: T.string
  })
};

ErrorBoundary.defaultProps = {
  notification: {}
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/ErrorBoundary.jsx